import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import App from "./App";
import { TweaksProvider } from "./lib/tweaks";

import "./styles/colors_and_type.css";
import "./styles/styles.css";
import "./styles/globals.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <TweaksProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </TweaksProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
